import { useState } from "react"
import { OpenXLogo } from "../../../assets/icons"
import bgImage from "../../../assets/webp/SignInBGImage.webp"
import { ButtonComponent } from "../../components/button"
import styles from "./style.module.css"
import { useInitializeResetPasswordMutation, useResetPasswordMutation, useVerifyResetPasswordTokenMutation } from "../../../redux/services/authApi"
import { useNavigate, useParams } from "react-router-dom"
import { useCreateStoreReviewMutation, useDeleteStoreReviewMutation, useGetReviewsByStoreQuery, useGetStoreReviewQuery, useUpdateStoreReviewMutation } from "../../../redux/services/storesApi"
import { skipToken } from "@reduxjs/toolkit/query"


export const ForgotPassword = () =>
{
    
    const [isLoading, setIsLoading] = useState(false);
    const [email, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("")
    const [initializeResetPassword] = useInitializeResetPasswordMutation();
    const [verifyResetPasswordToken] = useVerifyResetPasswordTokenMutation();
    const [resetPassword] = useResetPasswordMutation();
    const navigate = useNavigate();



      // const { review_id } = useParams<{ review_id: string }>();
      // const [ createStoreReview ] = useCreateStoreReviewMutation()
      // const [ updateStoreReview ] = useUpdateStoreReviewMutation()
      // const [ deleteStoreReview ] = useDeleteStoreReviewMutation()
  //     const {
  //   data: review,
  //   error,
  //   isLoading,
  // } = useGetStoreReviewQuery(review_id ?? "68d4160d55b2949c5e897eaf", {
  //   // skip: !review_id, // prevents running query if review_id is null
  // });

  //  const { store_id } = useParams<{ store_id: string }>();

  // const {
  //   data: reviews,
  //   error,
  //   isLoading,
  // } = useGetReviewsByStoreQuery(store_id ?? "68b80a7374838e407513777b", {
  //   // skip: !store_id,
  // });

  // if (isLoading) return <p>Loading review...</p>;
  // if (error) return <p>Error loading review</p>;


    const instructiontext = "Enter the email address linked to your OpenX account, and we'll send you a link to reset your password."

    const SendOTP = async () => 
    {




           //CREATE STORE INTEGRATION

        
    // try
    // {
    //    let response;
      
        //  response  = await createStoreReview({
      //   store_id: "68b80a7374838e407513777b", 
      //   rating: 3,
      //   title: "MBAISE STORE",
      //   comment: "OH MY GODD SOS NICEEE"
      // }).unwrap()


    //  response = await updateStoreReview({
    //   reviewId: "68d4160d55b2949c5e897eaf",
    //   body: {
    //     rating: 4,
    //     title: "Updated Store Review",
    //     comment: "This is even better than before!"
    //   }
    // }).unwrap();


    // response = await deleteStoreReview("68d421626e68766dd62b0222").unwrap();

    //   console.log("Review deleted successfully");
    //   console.log(response);
    // }
    // catch (err: any) 
    // {
    //   console.error('Failed:', err);
    //   const errorMessage = err.data?.message || 'Invalid credentials. Please try again.';
    //   setErrorMessage(errorMessage);
    // }
    // finally
    // {

    // }


  


    // END OF TESTS HERE








      setErrorMessage("");

      if(isLoading)
      {
        console.log("Still Processing")
        setIsLoading(false);
        return;
      }

      if(!isValidEmail(email))
      {
        console.log("• Email must be a valid email address")
        setErrorMessage("• Email must be a valid email address")
        setIsLoading(false);
        return;
      }

      setIsLoading(true);

      try {
        const payload = await initializeResetPassword({ email }).unwrap();
        const encodedEmail = encodeURIComponent(email);
        const verificationLink = `/forgotPassword-otp?email=${encodedEmail}`;
        navigate(verificationLink);
      } 
      catch (err: any) {
        console.error('API error:', err);

        // RTK Query wraps errors in a standard structure
        if (err?.data?.detail) {
          setErrorMessage(`• ${err.data.detail}`);
        console.log('API error:', err);

        } else if (err?.error) {
          setErrorMessage(`• ${err.error}`);
        console.log('API error:', err);

        } else {
          setErrorMessage('• Something went wrong. Please try again.');
        }
      } 
      finally {
        setIsLoading(false);
      }

    }

    function isValidEmail(email: string): boolean {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email.trim());
    }

    return (
              <div className={styles.container}>
        <img className={styles.bgImg} src={bgImage} alt="Gallery Image"></img>
        <div className={styles.entryContainer}>
          <OpenXLogo className={styles.icon} />
          <div className={styles.headerTxt}>Forgot Password?</div>
          <div className={styles.instr}> {instructiontext}</div>

           <div className={styles.field}>
            <label htmlFor="email" className={styles.label}>
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className={styles.input}
              placeholder="johndoe@mail.com"
              onChange={(e) => {setPassword(e.target.value)}}
            />
          <div className={styles.errMsg}>{errorMessage}</div>


            <ButtonComponent 
            buttonName={isLoading ? "Sending..." : "Send Link" }
            handleclick={SendOTP} 
            style={{ marginTop: 77, marginBottom: 36, 
              width: '100%', 
              height: '46px',
              border: 0,
              opacity: isLoading ? 0.5 : 1
              
            }}/>
            </div>

             {/* <div> */}
      {/* <h2>{review?.title}</h2>
      <p>Rating: {review?.rating}</p>
      <p>{review?.comment}</p>
      <small>Store ID: {review?.store_id}</small> */}
      {/* <p>Store REVIEW: {review?.rating}</p> */}
      {/* <p>Store REVIEW: {review?.rating}</p> */}


       {/* {reviews && reviews.length > 0 ? (
        reviews.map((review) => (
          <div key={review._id}>
            <h3>{review.title}</h3>
            <p>Rating: {review.rating}</p>
            <p>{review.comment}</p>
            <small>By user: {review.user_id}</small>
          </div>
        ))
      ) : (
        <p>No reviews for this store.</p>
      )} */}


    {/* </div> */}
          

          </div>
          </div>
    )
}